/* global logger */
class VolumeFormulaConvertor {
  constructor() {
    // Registry of conversion functions
    this.conversions = {
      CBM: {
        CFT: value => value * 35.315, // CBM → CFT
      },
      CFT: {
        CBM: value => value / 35.315, // CFT → CBM
      },
      // Add more units here
    };
    this.SYSTEM_UNIT = 'CFT';
  }

  /**
   * Convert value from one unit to another
   * @param {string} fromUnit - source unit (e.g., 'CBM')
   * @param {string} toUnit - target unit (e.g., 'CFT')
   * @param {number} value - value to convert
   */
  convert(fromUnit, toUnit, value) {
    if (!fromUnit || !toUnit || value === null || value === undefined || isNaN(value)) {
      console.error('[Volume-Formula-Convertor] Invalid parameters');
      return value;
    }

    if (value === 0) return 0;
    const from = fromUnit.toUpperCase();
    const to = toUnit.toUpperCase();
    if (from === to) return value;
    if (!this.conversions[from] || !this.conversions[from][to]) {
      console.error(`[Volume-Conversion-Error] Conversion from ${from} to ${to} not supported`);
      return value;
    }

    const convertedValue = this.conversions[from][to](value);
    return convertedValue ? parseFloat(convertedValue.toFixed(3)) : value;
  }

  /**
   * Convert to system unit (CFT)
   * @param {string} unit - source unit
   * @param {number} value - value to convert
   * @returns {number} converted value in system unit
   */
  convertToSystem(unit, value) {
    return this.convert(unit, this.SYSTEM_UNIT, value);
  }

  /**
   * Revert back to client unit
   */
  revertToClient(unit, value) {
    return this.convert(this.SYSTEM_UNIT, unit, value);
  }
}

// console.log(converter.convert("CBM", "CFT", 2));     // 70.63
// console.log(converter.convert("CFT", "CBM", 70.63)); // ~2
// console.log(converter.convertToSystem("CFT", 100));  // → 2.83 CBM
// console.log(converter.revertToClient("CFT", 2.83));  // → ~100

module.exports = VolumeFormulaConvertor;
